<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>

    <v-container fluid>
      <v-card elevation="0" class="pa-5">
        <v-row class="mb-4">
          <v-col cols="4"
          v-for="(plan, idx) in paymentPlans" :key="idx">
            <v-card
              outlined
            >
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-checkbox
                      v-model="selectedPlan"
                      :label="plan.name"
                      :value="plan.id"
                      class="ml-2"
                    ></v-checkbox>
                  </v-list-item-title>
                  <v-row>
                    <v-col class="addon-prices">
                      ${{ plan.price }}
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>

              <v-list dense>
                <v-list-item v-for="(feature, i) in plan.features" :key="i">
                  <v-list-item-icon>
                    <span class="material-icons">done</span>
                  </v-list-item-icon>
                  <v-list-item-content class="text-subtitle-2">
                    {{ feature }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>

            </v-card>
          </v-col>
        </v-row>

        <PayPal
          :amount="totalPrice.toString()"
          currency="USD"
          :client="credentials"
          env="sandbox"
          @payment-authorized="paymentAuthorized"
          @payment-completed="paymentCompleted"
          @payment-cancelled="paymentCancelled"
        >
        </PayPal>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import PayPal from 'vue-paypal-checkout'
export default {
  components: {
    PayPal
  },
  data () {
    return {
      name: 'Payment',
      selectedPlan: '',
      paymentPlans: [
        {
          id: 1,
          name: this.$t('payment.basicPlan'),
          price: '25',
          features: [
            '$25' + this.$t('payment.perReport'),
            this.$t('payment.deforestationAnalyticsCertificateDownload'),
          ] 
        },
        {
          id: 2,
          name: this.$t('payment.advancePlan'),
          price: '100',
          features: [
            `$100 ${this.$t('payment.usdPerMonthPlus')} $5 ${this.$t('perReport')}`,
            this.$t('payment.deforestationAnalyticsCertificateDownload'),
          ] 
        },
        {
          id: 3,
          name: 'Enterprise Plan',
          price: '1000',
          features: [
            `$1000 ${this.$t('payment.usdPerMonthPlus')} $2.50 ${this.$t('perReport')}`,
            this.$t('payment.deforestationAnalyticsCertificateDownload'),
          ] 
        }
      ],
      breadcrumbs: [
				{
					text: this.$t("dashboard"),
					disabled: false,
					to: "/",
				},
				{
					text: this.$t('paymentbr'),
					disabled: true,
					to: "/Payment",
				},
			],
      totalPrice: 10,
      credentials: {
        sandbox: "AQg0_sStegJDdn4y7X3F3SO8QpQBtegCld3pp42TbEIFnRLfmdM_DtCONxLQuXvviulx0k8kLdRf4m75",
        production: ""
      },
      customPaypalButton: {
        label: "checkout",
        size: "large",
        shape: "pill",
        color: "blue"
      },
    }
  }
}
</script>

<style>
.addon-prices{
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-left: 8px;
}
.addon-prices::before{
  content: "";
  width: 17px;
  height: 17px;
  display: inline-block;
  background-color: #d9d9d9;
  border-radius: 50%;
  margin-right: 5px;
}
</style>